module.exports = __webpack_public_path__ + "static/image/history/pc/201605@3x.jpg?942b9174";